import type { Tone } from '../types/content';

export const toneClasses: Record<Tone, string> = {
  accent: 'bg-accent-soft text-accent-ink',
  ok: 'bg-ok-soft text-ok-ink',
  warn: 'bg-warn-soft text-warn-ink',
  alert: 'bg-alert-soft text-alert-ink',
  neutral: 'bg-ink/[0.05] text-ink-muted',
};

export const toneDot: Record<Tone, string> = {
  accent: 'bg-accent',
  ok: 'bg-ok',
  warn: 'bg-warn',
  alert: 'bg-alert',
  neutral: 'bg-ink-faint',
};
